var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      staticClass: "col content-spacing",
      staticStyle: { "max-width": "88% !important" },
      attrs: { role: "main" }
    },
    [
      _c(
        "section",
        [
          _c(
            "PageHeader",
            {
              staticStyle: { "padding-top": "1rem" },
              attrs: { pageTitle: "Leads" }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", gap: "0.5rem" } },
                [
                  _c("MunicipioSelect", {
                    model: {
                      value: _vm.municipioList,
                      callback: function($$v) {
                        _vm.municipioList = $$v
                      },
                      expression: "municipioList"
                    }
                  }),
                  _vm._v(" "),
                  _c("CNAEFirstSelect", {
                    attrs: {
                      disabled: _vm.municipioList.length === 0,
                      selectedMunicipios: _vm.municipioList
                    },
                    model: {
                      value: _vm.cnaeList,
                      callback: function($$v) {
                        _vm.cnaeList = $$v
                      },
                      expression: "cnaeList"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    gap: "0.5rem",
                    "flex-direction": "column"
                  }
                },
                [
                  _vm._v("\n        Ano de início da atividade\n        "),
                  _c(
                    "div",
                    { staticStyle: { display: "flex", gap: "0.5rem" } },
                    [
                      _c("SelectYear", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          startYear: 1694,
                          placeholderText: "Ano inicial",
                          revertYear: ""
                        },
                        model: {
                          value: _vm.minStartActivityYear,
                          callback: function($$v) {
                            _vm.minStartActivityYear = $$v
                          },
                          expression: "minStartActivityYear"
                        }
                      }),
                      _vm._v(" "),
                      _c("SelectYear", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          startYear: _vm.computedMaxStartYear,
                          placeholderText: "Ano final",
                          revertYear: ""
                        },
                        model: {
                          value: _vm.maxStartActivityYear,
                          callback: function($$v) {
                            _vm.maxStartActivityYear = $$v
                          },
                          expression: "maxStartActivityYear"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "BaseButtonComponent",
                {
                  staticStyle: { padding: "1px 12px" },
                  attrs: {
                    variant: "primary-action",
                    disabled: _vm.disableSearchButton
                  },
                  on: { click: _vm.getLeads }
                },
                [_vm._v("\n        Buscar\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("b-skeleton-table", {
            staticStyle: { "margin-top": "2rem" },
            attrs: {
              animation: "wave",
              rows: 5,
              columns: 8,
              "table-props": { bordered: true, striped: true }
            }
          })
        : _c("LeadsTable", {
            attrs: { list: _vm.leads, isLoading: _vm.isLoading }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }